const doc = [({"en":({"js":({"shared":({"state_selector":({"state_was_updated":"State was updated"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;